import {Component, Input} from '@angular/core';

@Component({
    selector: 'listing-offer',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ListingOffer {
  @Input() extraInfo: any;
}
